var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var Brand = /** @class */ (function () {
    function Brand() {
    }
    return Brand;
}());
export { Brand };
;
;
// ---------------------------------------- [ HAND BAGGAGE ]
var HAND_BAGGAGE_BF = {
    id: 'bags',
    order: 3,
    type: 'added',
    label: 'Hand bagagge + 1 Personal Item',
    description: '1x 8kg allowed',
    icon: 'luggage--cabin_trolley',
    details: { label: 'Learn more', route: 'details-hand_luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-hand_luggage' }
};
// ---------------------------------------- [ PRIORITY BAGGAGE ]
var PRIORITY_BAGGAGE_BF = {
    id: 'priority-baggage',
    label: 'Priority baggage',
    description: '1x 23kg allowed',
    type: 'added',
    icon: 'luggage--priority',
    details: { label: 'Learn more', route: 'details-priority-luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-priority-luggage' }
};
// ---------------------------------------- [ CHECKED BAGGAGE ]
var CHECKED_BAGGAGE_BF = {
    id: 'checked-baggage',
    label: 'Checked baggage',
    order: 4,
    description: '1x 23kg allowed',
    amount: 1,
    type: 'added',
    icon: 'ancillaries--luggage',
    details: { label: 'Learn more', route: 'details-luggage' },
    flight_details: { label: 'Learn more', route: 'flight-details-luggage' }
};
// ---------------------------------------- [ EXTRA BAGGAGE ]
var EXTRA_BAGGAGE_BEF = {
    name: 'Checked bags',
    id: 'bags',
    label: 'Extra bags',
    description: 'From 47,00 EUR',
    type: 'extra',
    price: 47,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'add', route: 'checked-bags' },
    icon: 'ancillaries--luggage'
};
// ---------------------------------------- [ DIGITAL_KIOSK ] (tinha export)
var DIGITAL_KIOSK_BF = {
    id: 'kiosk',
    label: 'Digital Kiosk',
    type: 'added',
    description: 'This passenger has access to 7 titles',
    details: { label: 'Learn more', route: 'details-kiosk' },
    icon: 'leisure_and_commodities--magazines',
    flight_details: { label: 'Learn more', route: 'details-kiosk' },
};
// ---------------------------------------- [ SPORTS_EQUIPMENT ]
var SPORTS_EQUIPMENT_BF = {
    id: 'sports',
    label: 'Sports Equipment',
    type: 'added',
    details: { label: 'Learn more', route: 'sports-equipment' },
    icon: 'ancillaries--sports_equipment'
};
var SPORTS_EQUIPMENT_BEF = {
    name: 'Sports equipments',
    id: 'sports',
    label: 'Sports equipment',
    description: 'From 20,00 EUR',
    type: 'extra',
    price: 20,
    secondary: true,
    secondary_on_mobile: true,
    action: { label: 'Choose', route: 'ancillaries--sports_equipment' },
    icon: 'ancillaries--sports_equipment',
    highlight: true
};
// ---------------------------------------- [ MUSICAL_EQUIPMENT ]
var MUSICAL_EQUIPMENT_BF = {
    id: 'instruments',
    label: 'Musical Equipment',
    type: 'added',
    details: { label: 'Learn more', route: 'musical-equipment' },
    icon: 'luggage--music_equipment'
};
var MUSICAL_EQUIPMENT_BEF = {
    name: 'Music instruments',
    id: 'instruments',
    label: 'Music instruments',
    description: 'From 15,00 EUR',
    type: 'extra',
    price: 15,
    previous_price: 20,
    secondary: true,
    secondary_on_mobile: true,
    action: { label: 'Choose', route: 'ancillaries--music-instruments' },
    icon: 'luggage--music_equipment'
};
// ---------------------------------------- [ PREMIUM_CUSTOMER_CENTRE ]
var PREMIUM_CUSTOMER_CENTRE_BF = {
    id: 'premium-customer-centre',
    label: 'Premium Customer Centre',
    type: 'added',
    order: 9,
    details: { label: 'Learn more', route: 'premium-customer-centre' },
    icon: 'support--premium_customer_service',
    flight_details: { label: 'Learn more', route: 'flight-details-premium-customer-centre' }
};
// ---------------------------------------- [ PREMIUM_BOARDING ]
var PREMIUM_BOARDING_BF = {
    id: 'differentiated-boarding',
    label: 'Premium Boarding',
    type: 'added',
    order: 10,
    details: { label: 'Learn more', route: 'premium-boarding' },
    icon: 'airport--differentiated_boarding',
    flight_details: { label: 'Learn more', route: 'flight-details-differentiated_boarding' },
};
// ---------------------------------------- [ PRIORITY_CHECK_IN ]
var PRIORITY_CHECK_IN_BF = {
    id: 'priority-checkin',
    label: 'Priority Check In',
    type: 'added',
    order: 11,
    details: { label: 'Learn more', route: 'priority-checkin' },
    icon: 'check-in--priority',
    flight_details: { label: 'Learn more', route: 'flight-details-priority-checkin' }
};
// ---------------------------------------- [ AUTOMATIC_CHECKIN ]
var AUTOMATIC_CHECKIN_BF = {
    id: 'automatic-checkin',
    label: 'Automatic Checkin',
    details: { label: 'Learn more', route: 'details-automaticCheckin' },
    type: 'added',
    flight_details: { label: 'Learn more', route: 'details-automaticCheckin' },
    icon: 'check-in--automatic'
};
var AUTOMATIC_CHECKIN_BEF = {
    name: 'Automatic Checkin',
    id: 'automatic-checkin',
    label: 'Automatic checkin',
    description: 'From 10.00 EUR',
    type: 'extra',
    price: 10,
    previous_price: 20,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'Add', route: 'automatic-checkin' },
    icon: 'check-in--automatic',
    highlight: true
};
// ---------------------------------------- [ PREFERRED_BOARDING ]
var PREFERRED_BOARDING_BEF = {
    name: 'Preferred Boarding',
    id: 'preferred-boarding',
    label: 'Preferred Boarding',
    description: 'From 20,00 EUR',
    type: 'extra',
    price: 20,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'Add', route: 'preferred-boarding' },
    icon: 'plane_related--preferred-board'
};
// ---------------------------------------- [ FAST TRACK ]
var FAST_TRACK_BEF = {
    name: 'Fast Track',
    id: 'fasttrack',
    label: 'Fast Track',
    description: 'From 20 EUR',
    type: 'extra',
    price: 20,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'Add', route: 'fast-track' },
    icon: 'plane_related--fast_track'
};
// ---------------------------------------- [ PETS ]
var PETS_BF = {
    id: 'pets',
    label: 'Pets',
    type: 'added',
    details: { label: 'Learn more', route: 'pets' },
    icon: 'luggage--small_pets'
};
var PETS_BEF = {
    name: 'Small pets',
    id: 'pets',
    label: 'Small pets from 35,00 EUR',
    description: 'From 35,00 EUR',
    type: 'extra',
    price: 35,
    secondary: true,
    secondary_on_mobile: true,
    action: { label: 'Choose', route: 'ancillaries--small-pets' },
    icon: 'luggage--small_pets',
};
// ---------------------------------------- [ DETAILS_LOUNGE ]
var DETAILS_LOUNGE_BF = {
    id: 'lounge',
    label: 'Lounge access',
    description: 'Free to access lounge for all passengers',
    type: 'added',
    order: 7,
    details: { label: 'Learn more', route: 'details-lounge' },
    icon: 'ancillaries--lounge',
    flight_details: { label: 'Learn more', route: 'flight-details-lounge' }
};
var DETAILS_LOUNGE_BEF = {
    label: 'Lounge',
    description: 'from 15,00 EUR',
    type: 'extra',
    price: 15,
    secondary: false,
    secondary_on_mobile: true,
    action: { label: 'add', route: 'ancillaries--lounge' },
    icon: 'ancillaries--lounge',
    name: 'Lounge',
    id: 'lounge'
};
// ---------------------------------------- [ Packs ]
var PACK1_BEF = {
    label: 'Bundle offer 1',
    description: '',
    type: 'pack',
    price: 15,
    services: [
        { id: 'preferred-boarding', value: true },
        { id: 'fasttrack', value: true }
    ],
    action: { label: 'add', route: 'pack' },
    name: 'pack1',
    id: 'pack1',
    order: 0
};
var PACK2_BEF = {
    label: 'Bundle offer 2',
    description: '',
    type: 'pack',
    price: 150,
    services: [
        { id: 'sports', value: 'surf' },
        { id: 'bags', value: 'second' }
    ],
    action: { label: 'add', route: 'pack' },
    name: 'pack2',
    id: 'pack2',
    order: 0
};
var PACK3_BEF = {
    label: 'Bundle offer 3',
    description: '',
    type: 'pack',
    price: 100,
    services: [
        { id: 'preferred-boarding', value: true },
        { id: 'bags', value: 'extra' }
    ],
    action: { label: 'add', route: 'pack' },
    name: 'pack3',
    id: 'pack3',
    order: 0
};
var PACK4_BEF = {
    label: 'Bundle offer 4',
    description: '',
    type: 'pack',
    price: 100,
    services: [
        { id: 'preferred-boarding', value: true },
        { id: 'automatic-checkin', value: true }
    ],
    action: { label: 'add', route: 'pack' },
    name: 'pack4',
    id: 'pack4',
    order: 0
};
// ---------------------------------------- [ MILES & GO ]
var MILES_BF = {
    id: 'miles',
    label: 'Miles',
    type: 'added',
    order: 1,
    description: 'For Miles&GO members only',
    details: { label: 'Learn more', route: 'details-loyalty_miles' },
    icon: 'loyalty--miles',
    flight_details: { label: 'Learn more', route: 'flight-details-miles' },
};
// ---------------------------------------- [ MEALS ]
var MEAL_BF = {
    id: 'meals',
    label: 'Meal',
    type: 'added',
    order: 5,
    description: 'For free. May include dairy and other allergens',
    icon: 'food_drinks--cold_meals',
    details: { label: 'Learn more', route: 'details-snacks' },
    flight_details: { label: 'Learn more', route: 'flight-details-meals' }
};
var MEAL_BEF = {
    name: 'meals',
    id: 'meals',
    label: 'Special meals for free',
    description: 'Free for people with food restrictions',
    type: 'extra',
    price: 0,
    secondary: true,
    secondary_on_mobile: true,
    action: { label: 'choose', route: 'ancillaries--special-meals' },
    icon: 'ancillaries--special_meals'
};
// ---------------------------------------- [ SEAT RESERVATION ]
var SEAT_RESERVATION_BF = {
    id: 'seats',
    label: 'Standard seat reservation',
    order: 4,
    description: 'Free seat reservation in standard area',
    type: 'added',
    icon: 'plane_related--seat',
    details: { label: 'Learn more', route: 'details-seat' },
    flight_details: { label: 'Learn more', route: 'flight-details-seat' }
};
var SEAT_AREA_SELECT_BEF = {
    name: 'Seats',
    id: 'seats',
    label: 'Choose a seating area',
    description: 'Seats',
    type: 'extra',
    price: 0,
    secondary: false,
    secondary_on_mobile: false,
    action: { label: 'Choose', route: 'seatmap' },
    icon: 'plane_related--seat',
};
// ---------------------------------------- [ SEAT RESERVATION ]
var COMFORT_SEAT_RESERV_BF = {
    id: 'seats',
    label: 'Comfort seat reservation',
    order: 4,
    description: 'Extra legroom & reclining',
    type: 'added',
    icon: 'plane_related--tap_executive',
    details: { label: 'Learn more', route: 'comfort-seat' },
    flight_details: { label: 'Learn more', route: 'comfort-seat' }
};
// ---------------------------------------- [ FAST TRACK ]
var FAST_TRACK_BF = {
    id: 'fasttrack',
    label: 'Fast track',
    type: 'added',
    description: 'All passengers can get faster through security',
    flight_details: { label: 'Learn more', route: 'flight-details-fast_track' },
    icon: 'plane_related--fast_track',
    details: { label: 'Learn more', route: 'details-fast_track' }
};
// ---------------------------------------- [ FREE CHANGES ]
var FREE_CHANGES_BF = {
    id: 'changes',
    label: 'Free changes',
    type: 'added',
    description: 'Schedule or date changes allowed',
    icon: 'airport--changes',
    details: { label: 'Learn more', route: 'details-changes' },
    flight_details: { label: 'Learn more', route: 'flight-details-changes' },
};
// ---------------------------------------- [ REFUNDABLE ]
var REFUNDABLE_BF = {
    id: 'refunds',
    label: 'Refundable',
    type: 'available',
    order: 99,
    icon: 'money_related--refund',
    details: { label: 'Learn more', route: 'details-refunds' },
    flight_details: { label: 'Learn more', route: 'flight-details-refunds' }
};
// ---------------------------------------- [ WIFI ONBOARD ]
var WIFI_BF = {
    id: 'wifi-onboard',
    label: 'Wifi onboard',
    description: 'Internet Wi-Fi pack',
    type: 'added',
    details: { label: 'Learn more', route: 'flight-details-wifi' },
    icon: 'digital_universe--wifi',
    flight_details: { label: 'Learn more', route: 'flight-details-wifi' }
};
var WIFI_BEF = {
    label: 'Internet Wi-Fi onboard',
    description: 'Add internet Wi-Fi pack',
    type: 'extra',
    price: 20,
    secondary: false,
    secondary_on_mobile: false,
    action: {
        label: 'Choose',
        route: 'wifi-onboard'
    },
    icon: 'digital_universe--wifi',
    name: 'wifi',
    id: 'wifi'
};
// ---------------------------------------- [ FEATURES PACKS ]
var NO_PREMIUM_FEATURES = [
    __assign({}, PREMIUM_CUSTOMER_CENTRE_BF, { type: 'unavailable' }),
    __assign({}, PREMIUM_BOARDING_BF, { type: 'unavailable' }),
    __assign({}, PRIORITY_CHECK_IN_BF, { type: 'unavailable' })
];
var DETAILS_NO_LOUNGE = __assign({}, DETAILS_LOUNGE_BF, { type: 'available', description: 'from 25€', price: 25 });
export var PASSENGER_INCLUDED_EXTRAS = [
    DIGITAL_KIOSK_BF,
    PETS_BF,
    SPORTS_EQUIPMENT_BF,
    MUSICAL_EQUIPMENT_BF
];
// ---------------------------------------- [ FEATURES PACKS to Export]
export var DIGITAL_KIOSK = DIGITAL_KIOSK_BF;
export var WIFI_ONBOARD = WIFI_BEF;
export var PACK1 = PACK1_BEF;
export var PACK2 = PACK2_BEF;
export var PACK3 = PACK3_BEF;
export var PACK4 = PACK4_BEF;
export var PACK_LIST = [PACK1_BEF, PACK2_BEF, PACK3_BEF];
export var WIFI_ONBOARD_FEATURE = WIFI_BF;
export var AUTOMATIC_CHECKIN_FEATURE = AUTOMATIC_CHECKIN_BF;
export var PASSENGER_INCLUDED_LINKS = [
    DIGITAL_KIOSK_BF,
    PETS_BF,
    SPORTS_EQUIPMENT_BF,
    MUSICAL_EQUIPMENT_BF,
    {
        label: 'José Simões is a GOLD Member',
        cssClass: 'hide-on-print',
        description: '',
        type: 'added',
        secondary: false,
        secondary_on_mobile: false,
        icon: null,
        included: { label: 'View all benefits' }
    },
    {
        label: '',
        cssClass: 'hide-on-print',
        description: '',
        type: 'added',
        secondary: false,
        secondary_on_mobile: false,
        icon: null,
        included: {
            label: 'See what′s included per passenger'
        }
    }
];
export var DEFAULT_FEATURES = [
    __assign({}, MILES_BF, { order: 2 }),
    HAND_BAGGAGE_BF,
    __assign({}, MEAL_BF, { description: 'May include dairy and other allergens', icon: 'ancillaries--meals', details: { label: 'Learn more', route: 'details-meals' } })
];
export var ECONOMY_EXTRAS_SECONDARY_FEATURES = [
    DETAILS_LOUNGE_BEF,
    SPORTS_EQUIPMENT_BEF,
    PREFERRED_BOARDING_BEF,
    MUSICAL_EQUIPMENT_BEF,
    PETS_BEF,
    MEAL_BEF
];
export var BUSINESS_EXTRAS_SECONDARY_FEATURES = [
    SPORTS_EQUIPMENT_BEF,
    MUSICAL_EQUIPMENT_BEF,
    PETS_BEF
];
export var DISCOUNT_FEATURES = [
    HAND_BAGGAGE_BF,
    AUTOMATIC_CHECKIN_BEF,
    PREFERRED_BOARDING_BEF,
    FAST_TRACK_BEF,
    EXTRA_BAGGAGE_BEF,
    SPORTS_EQUIPMENT_BEF,
    MUSICAL_EQUIPMENT_BEF,
    PETS_BEF,
    DETAILS_LOUNGE_BEF,
    __assign({}, MEAL_BEF, { label: 'Choose your onboard meal', description: 'Choose onboard menu', secondary: false, secondary_on_mobile: false }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose a seating area', price: 10, previous_price: 20 })
];
export var BASIC_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    AUTOMATIC_CHECKIN_BEF,
    PREFERRED_BOARDING_BEF,
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose a seating area', price: 10, previous_price: 20 }),
    EXTRA_BAGGAGE_BEF
];
export var CLASSIC_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    SEAT_RESERVATION_BF,
    SEAT_AREA_SELECT_BEF,
    AUTOMATIC_CHECKIN_BF,
    PREFERRED_BOARDING_BEF
];
export var PLUS_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    COMFORT_SEAT_RESERV_BF,
    AUTOMATIC_CHECKIN_BF,
    PREFERRED_BOARDING_BEF,
    MEAL_BF,
    PREMIUM_BOARDING_BF,
    FAST_TRACK_BF,
    FREE_CHANGES_BF,
    PRIORITY_BAGGAGE_BF,
    SEAT_AREA_SELECT_BEF,
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 })
];
export var EXECUTIVE_UPGRADE36_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    PRIORITY_BAGGAGE_BF,
    MEAL_BF,
    AUTOMATIC_CHECKIN_BF,
    EXTRA_BAGGAGE_BEF,
    PREMIUM_CUSTOMER_CENTRE_BF,
    PREMIUM_BOARDING_BF,
    PRIORITY_CHECK_IN_BF,
    __assign({}, DETAILS_LOUNGE_BF, { description: "Free to access lounge, when available" }),
    __assign({}, FAST_TRACK_BF, { description: "All passengers can get faster through security, when available", order: 6 }),
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 }),
    __assign({}, SEAT_RESERVATION_BF, { label: 'Free seat reservation', description: 'In any area' }),
    __assign({}, MEAL_BEF, { label: 'Choose your onboard meal', description: 'Choose onboard menu', secondary: false, secondary_on_mobile: false }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose any seating area for free', description: 'Any seat free' })
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var EXECUTIVE_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    PRIORITY_BAGGAGE_BF,
    MEAL_BF,
    AUTOMATIC_CHECKIN_BF,
    EXTRA_BAGGAGE_BEF,
    PREMIUM_CUSTOMER_CENTRE_BF,
    PREMIUM_BOARDING_BF,
    PRIORITY_CHECK_IN_BF,
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 }),
    __assign({}, SEAT_RESERVATION_BF, { label: 'Free seat reservation', description: 'In any area' }),
    __assign({}, FAST_TRACK_BF, { order: 6 }),
    __assign({}, FREE_CHANGES_BF, { order: 8 }),
    __assign({}, MEAL_BEF, { label: 'Choose your onboard meal', description: 'Choose onboard menu', secondary: false, secondary_on_mobile: false }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose any seating area for free', description: 'Any seat free' }),
    __assign({}, REFUNDABLE_BF, { price: 100 })
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var MILES_GO_FEATURES = [
    __assign({}, HAND_BAGGAGE_BF, { label: 'Hand baggage' }),
    __assign({}, FAST_TRACK_BF, { order: 6 }),
    __assign({}, DETAILS_LOUNGE_BF, { description: 'This passenger can access the lounge\nwhen available' }),
    PREMIUM_CUSTOMER_CENTRE_BF,
    PREMIUM_BOARDING_BF,
    PRIORITY_BAGGAGE_BF,
    PRIORITY_CHECK_IN_BF,
    DIGITAL_KIOSK_BF
];
export var TOP_EXECUTIVE_FEATURES = [
    MILES_BF,
    HAND_BAGGAGE_BF,
    PRIORITY_BAGGAGE_BF,
    MEAL_BF,
    AUTOMATIC_CHECKIN_BF,
    PREMIUM_CUSTOMER_CENTRE_BF,
    PREMIUM_BOARDING_BF,
    PRIORITY_CHECK_IN_BF,
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 }),
    __assign({}, SEAT_RESERVATION_BF, { label: 'Free seat reservation', description: 'In any area' }),
    __assign({}, FAST_TRACK_BF, { order: 6 }),
    __assign({}, FREE_CHANGES_BF, { order: 8 }),
    __assign({}, MEAL_BEF, { label: 'Choose your onboard meal', description: 'Choose onboard menu', secondary: false, secondary_on_mobile: false }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose any seating area for free', description: 'Any seat free' }),
    __assign({}, EXTRA_BAGGAGE_BEF, { price: 0, label: 'Extra bags from 47,00€', description: 'From 47,00€' }),
    __assign({}, REFUNDABLE_BF, { type: 'added' })
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_ECONOMY = [
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    SEAT_RESERVATION_BF,
    __assign({}, FAST_TRACK_BF, { order: 5 }),
    __assign({}, MEAL_BF, { order: 6, type: 'unavailable', description: 'Meal not included' }),
    __assign({}, PRIORITY_BAGGAGE_BF, { type: 'unavailable' }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose a seating area from 12,00€', description: 'Seats from 12€', price: 12 }),
    __assign({}, EXTRA_BAGGAGE_BEF, { label: 'Extra bags from 22,00€', description: 'from 22€', price: 22 })
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_ECONOMY_EXTRA = [
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    COMFORT_SEAT_RESERV_BF,
    __assign({}, FAST_TRACK_BF, { order: 5 }),
    __assign({}, MEAL_BF, { order: 6 }),
    __assign({}, PRIORITY_BAGGAGE_BF, { type: 'unavailable' }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose a seating area from 0€', price: 12 }),
    __assign({}, EXTRA_BAGGAGE_BEF, { label: 'Extra bags from 22,00€', description: 'from 22€', price: 22 })
].concat(ECONOMY_EXTRAS_SECONDARY_FEATURES);
export var TAP_MILES_GO_EXECUTIVE = [
    HAND_BAGGAGE_BF,
    PRIORITY_BAGGAGE_BF,
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 }),
    __assign({}, SEAT_RESERVATION_BF, { label: 'Free seat reservation', description: 'In standard and preferred areas' }),
    __assign({}, FAST_TRACK_BF, { order: 5 }),
    __assign({}, MEAL_BF, { order: 6 }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
    __assign({}, SEAT_AREA_SELECT_BEF, { label: 'Choose any seating area for free', price: 12 }),
    __assign({}, MEAL_BEF, { label: 'Choose your onboard meal', description: 'Choose onboard menu', secondary: false, secondary_on_mobile: false }),
    __assign({}, EXTRA_BAGGAGE_BEF, { label: 'Extra bags from 22,00€', description: 'from 22€', price: 22 })
].concat(BUSINESS_EXTRAS_SECONDARY_FEATURES);
export var STAR_ALLIANCE_ECONOMY = [
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    MEAL_BF,
    __assign({}, FAST_TRACK_BF, { order: 7, type: 'unavailable' }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
];
export var STAR_ALLIANCE_BUSINESS = [
    HAND_BAGGAGE_BF,
    CHECKED_BAGGAGE_BF,
    __assign({}, FAST_TRACK_BF, { order: 7 }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
    __assign({}, MEAL_BF, { label: 'Business Meal' })
];
export var STAR_ALLIANCE_FIRST = [
    HAND_BAGGAGE_BF,
    __assign({}, CHECKED_BAGGAGE_BF, { amount: 2 }),
    __assign({}, FAST_TRACK_BF, { order: 7 }),
    __assign({}, FREE_CHANGES_BF, { label: 'Changes', type: 'available', price: 100, order: 8 }),
    __assign({}, REFUNDABLE_BF, { price: 10 }),
    __assign({}, MEAL_BF, { label: 'First Class Meal' }),
];
export var PACKS = [
    PACK1_BEF,
    PACK2_BEF,
    PACK3_BEF,
    PACK4_BEF
];
export var getPacks = function (brandId) {
    var packList = [];
    brandId = brandId ? brandId.toLowerCase() : '';
    switch (brandId) {
        case 'discount':
            packList = [PACK1_BEF, PACK2_BEF, PACK3_BEF];
            break;
        case 'basic':
        case 'classic':
            packList = [PACK3_BEF, PACK4_BEF];
            break;
    }
    return packList;
};
export var getBrands = function (options) {
    if (options === void 0) { options = { brands: false }; }
    var brandsList = [
        {
            label: 'Economy',
            label_sufix: 'from',
            brands: [
                { name: 'discount' },
                { name: 'basic' },
                { name: 'classic' },
                { name: 'plus' }
            ]
        },
        {
            label: 'Executive',
            label_sufix: 'from',
            brands: [
                { name: 'executive' },
                { name: 'top-executive' }
            ]
        },
        {
            label: 'Economy/Executive',
            label_sufix: 'from',
            brands: [
                { name: 'milesgo-economy' },
                { name: 'miles&go-extra' },
                { name: 'miles&go-executive' }
            ]
        },
        {
            label: 'Economy/Executive',
            label_sufix: 'from',
            brands: [
                { name: 'star_alliance-economy' },
                { name: 'star_alliance-business' },
                { name: 'star_alliance-first' }
            ]
        }
    ];
    if (options.brands) {
        return brandsList.reduce(function (acc, cur) { cur.brands.map(function (c) { return acc.push(c.name); }); return acc; }, []);
    }
    return brandsList;
};
export var getBrandFeatures = function (brand, options, order) {
    if (options === void 0) { options = { NO_PREMIUM_FEATURES: false }; }
    if (order === void 0) { order = true; }
    // return this.EXAMPLE_FEATURES;
    var featureList = [];
    brand = brand ? brand.toLowerCase() : '';
    switch (brand) {
        case 'discount':
            featureList = [].concat(DISCOUNT_FEATURES);
            break;
        case 'basic':
            featureList = !options.NO_PREMIUM_FEATURES ? BASIC_FEATURES : [].concat(BASIC_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'classic':
            featureList = !options.NO_PREMIUM_FEATURES ? CLASSIC_FEATURES : [].concat(CLASSIC_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'plus':
            featureList = !options.NO_PREMIUM_FEATURES ? PLUS_FEATURES : [].concat(PLUS_FEATURES, NO_PREMIUM_FEATURES);
            break;
        case 'executive':
            featureList = EXECUTIVE_FEATURES;
            break;
        case 'top-executive':
            featureList = TOP_EXECUTIVE_FEATURES;
            break;
        case 'miles&go-economy':
            featureList = TAP_MILES_GO_ECONOMY;
            break;
        case 'miles&go-extra':
            featureList = TAP_MILES_GO_ECONOMY_EXTRA;
            break;
        case 'miles&go-executive':
            featureList = TAP_MILES_GO_EXECUTIVE;
            break;
        case 'star_alliance-economy':
            featureList = STAR_ALLIANCE_ECONOMY;
            break;
        case 'star_alliance-business':
            featureList = STAR_ALLIANCE_BUSINESS;
            break;
        case 'star_alliance-first':
            featureList = STAR_ALLIANCE_FIRST;
            break;
        case 'executive_upgrade36':
            featureList = EXECUTIVE_UPGRADE36_FEATURES;
            break;
        default:
            featureList = DEFAULT_FEATURES;
            break;
    }
    if (order) {
        featureList = featureList.slice().sort(function (a, b) { return a.order && b.order && parseFloat(a.order) - parseFloat(b.order); });
    }
    return featureList;
};
/**
 * Get pack services. Services are ALWAYS listed among the extras associated with selected brand.
 */
export var getPackFeatures = function (packId) {
    var pack = PACKS.find(function (p) { return p.id == packId; });
    var services = DISCOUNT_FEATURES.filter(function (s) {
        return s.type == 'extra' && pack.services.some(function (e) { return e.id == s.id; });
    });
    var index = services.findIndex(function (s) { return s.id == 'bags'; });
    var ser = __assign({}, EXTRA_BAGGAGE_BEF, { label: 'Second Bag' });
    if (index >= 0 && packId == 'pack3')
        services.splice(index, 1, ser);
    return services;
};
export var getFeaturesPerPackLabel = function (brand, packID) {
    var refLabel = '';
    var packInfo = PACK_LIST.find(function (item) { return item.id === packID; });
    var fList = getBrandFeatures(brand);
    if (packInfo && fList) {
        packInfo.services.forEach(function (element) {
            var fInfo = fList.find(function (item) { return element.value = true && item.id === element.id; });
            if (fInfo.label) {
                if (refLabel)
                    refLabel += ' + ';
                refLabel += '<CNT>' + fInfo.label;
            }
        });
    }
    return { label: refLabel, price: packInfo.price };
};
